import { IconHeartFill, IconHeartOutline } from 'assets/svg/sprite'

import styles from './mediaItemSidebar.module.scss'

interface Props {
  likeCb?: () => void
  liked: boolean
  count: number
  price?: number | null
  isMessage?: boolean
  /** Hide the like UI entirely (e.g., deleted purchased media) */
  hideLike?: boolean
}

export const MediaItemSidebar = ({ likeCb, liked, count, price, isMessage, hideLike }: Props) => {
  const showLikeButton = !isMessage && !hideLike && !!likeCb
  const showLikeCount  = showLikeButton && price == null

  return (
    <div className={styles.wrapper} data-prevent-open>
      {showLikeButton && (
        <div
          className={styles.icon}
          data-prevent-open
          onPointerDown={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation()
            likeCb?.()
          }}
          role="button"
          aria-pressed={liked}
          aria-label={liked ? 'Unlike' : 'Like'}
        >
          {liked ? <IconHeartFill /> : <IconHeartOutline color="#fff" />}
        </div>
      )}

      {showLikeCount && (
        <div className={styles.count} data-prevent-open>
          {count}
        </div>
      )}
    </div>
  )
}
